import {Inject, Injectable} from '@angular/core';
import { CplRequestItem } from '../model/cpl-request-item.model';
import { CplRequestBasicData } from '../model/cpl-request-basic-data.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CplRequestDuplicateData } from '../model/cpl-request-duplicate-data.model';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';

@Injectable()
export class RequestItemApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    convertToTemplate(requestData: CplRequestDuplicateData) {
        return this.http.put(this.baseUri + '/cplrequest/template', requestData);
    }

    createItem(requestItem: CplRequestItem) {
        return this.http.post(this.baseUri + '/cplrequest', requestItem);
    }

    deleteItem(requestId: CplRequestBasicData) {
        return this.http.request('delete', this.baseUri + '/cplrequest', {
            responseType: 'text',
            body: requestId
        });
    }

    duplicateItem(requestData: CplRequestDuplicateData) {
        return this.http.put(this.baseUri + '/cplrequest/duplicate', requestData);
    }

    activateItem(requestId: CplRequestBasicData) {
        return this.http.put(this.baseUri + '/cplrequest/activate', requestId, { responseType: 'text' });
    }

    archiveItem(requestId: CplRequestBasicData) {
        return this.http.put(this.baseUri + '/cplrequest/archive', requestId, { responseType: 'text' });
    }

    getArchiveWarnings(requestId: string) {
        return this.http.get(this.baseUri + '/cplrequest/archiveWarnings/' + requestId);
    }

    restoreItem(requestId: CplRequestBasicData) {
        return this.http.put(this.baseUri + '/cplrequest/restore', requestId, { responseType: 'text' });
    }

    getRequestItem(requestID: String, includeUserStatusCounts: boolean = false) {
        const params = new HttpParams()
            .append('includeUserStatusCounts', String(includeUserStatusCounts));

        return this.http.get(this.baseUri + '/cplrequest/' + requestID, {
            params
        });
    }

    requestAccess(requestId: string) {
        return this.http.post(this.baseUri + '/cplrequest/requestAccess/' + requestId, {});
    }

    updateRequestItem(requestItem: CplRequestItem) {
        return this.http.put(this.baseUri + '/cplrequest', requestItem);
    }

    getRequestItems(offset: number, limit: number, orderBy: string, ascending: boolean, type:number, searchBy: string, status: number, tag: number) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy))
            .append('status', String(status))
            .append('tag', String(tag))
            .append('type', String(type));

        return this.http.get(this.baseUri + '/cplrequests', {
            params
        });
    }
    getOpenRequestItems(offset: number, limit: number, orderBy: string, ascending: boolean, searchBy: string, status: number, tag: number) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy))
            .append('status', String(status))
            .append('tag', String(tag));

        return this.http.get(this.baseUri + '/cplrequests/openrequests', {
            params
        });
    }
}